/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PageSetting,
    PageSettingFromJSON,
    PageSettingToJSON,
    PageSettingDto,
    PageSettingDtoFromJSON,
    PageSettingDtoToJSON,
} from '../models';

export interface GetPageSettingByUrlUsingGETRequest {
    url: string;
}

export interface ManageMessageUsingPOSTRequest {
    message: string;
    enable: boolean;
    startDate: string;
    endDate: string;
}

export interface UpdatePageSettingUsingPOSTRequest {
    id: number;
    name?: string;
    pageSettingDto?: PageSettingDto;
}

/**
 * 
 */
export class PageSettingControllerApi extends runtime.BaseAPI {

    /**
     * getAllPageSetting
     */
    async getAllPageSettingUsingGETRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<PageSetting>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/pageSetting/get/page_setting`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PageSettingFromJSON));
    }

    /**
     * getAllPageSetting
     */
    async getAllPageSettingUsingGET(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<PageSetting>> {
        const response = await this.getAllPageSettingUsingGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * getMessage
     */
    async getMessageUsingGETRaw(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PageSetting>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/pageSetting/getMessage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageSettingFromJSON(jsonValue));
    }

    /**
     * getMessage
     */
    async getMessageUsingGET(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PageSetting> {
        const response = await this.getMessageUsingGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * getPageSettingByUrl
     */
    async getPageSettingByUrlUsingGETRaw(requestParameters: GetPageSettingByUrlUsingGETRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PageSetting>> {
        if (requestParameters.url === null || requestParameters.url === undefined) {
            throw new runtime.RequiredError('url','Required parameter requestParameters.url was null or undefined when calling getPageSettingByUrlUsingGET.');
        }

        const queryParameters: any = {};

        if (requestParameters.url !== undefined) {
            queryParameters['url'] = requestParameters.url;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/pageSetting/get/page_setting/{url}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageSettingFromJSON(jsonValue));
    }

    /**
     * getPageSettingByUrl
     */
    async getPageSettingByUrlUsingGET(requestParameters: GetPageSettingByUrlUsingGETRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PageSetting> {
        const response = await this.getPageSettingByUrlUsingGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * manageMessage
     */
    async manageMessageUsingPOSTRaw(requestParameters: ManageMessageUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PageSetting>> {
        if (requestParameters.message === null || requestParameters.message === undefined) {
            throw new runtime.RequiredError('message','Required parameter requestParameters.message was null or undefined when calling manageMessageUsingPOST.');
        }

        if (requestParameters.enable === null || requestParameters.enable === undefined) {
            throw new runtime.RequiredError('enable','Required parameter requestParameters.enable was null or undefined when calling manageMessageUsingPOST.');
        }

        if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
            throw new runtime.RequiredError('startDate','Required parameter requestParameters.startDate was null or undefined when calling manageMessageUsingPOST.');
        }

        if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
            throw new runtime.RequiredError('endDate','Required parameter requestParameters.endDate was null or undefined when calling manageMessageUsingPOST.');
        }

        const queryParameters: any = {};

        if (requestParameters.message !== undefined) {
            queryParameters['message'] = requestParameters.message;
        }

        if (requestParameters.enable !== undefined) {
            queryParameters['enable'] = requestParameters.enable;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/pageSetting/manageMessage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageSettingFromJSON(jsonValue));
    }

    /**
     * manageMessage
     */
    async manageMessageUsingPOST(requestParameters: ManageMessageUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PageSetting> {
        const response = await this.manageMessageUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * updatePageSetting
     */
    async updatePageSettingUsingPOSTRaw(requestParameters: UpdatePageSettingUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<PageSetting>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePageSettingUsingPOST.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["JWT"] = this.configuration.apiKey("JWT"); // JWT authentication
        }

        const response = await this.request({
            path: `/pageSetting/update/page_setting`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PageSettingDtoToJSON(requestParameters.pageSettingDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageSettingFromJSON(jsonValue));
    }

    /**
     * updatePageSetting
     */
    async updatePageSettingUsingPOST(requestParameters: UpdatePageSettingUsingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<PageSetting> {
        const response = await this.updatePageSettingUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
